import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";

import components, { IWinfaktVueComponentsOptions } from "winfakt-vue-components";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { i18n, loadLanguageAsync } from "./setup/i18n-setup";

import { AuthService } from "./services/auth-service";
AuthService.init();

Vue.use(components, {
	defaultDatatableCompare: (a: {ID:number}, b: {ID:number}) => a.ID == b.ID,
	iconFonts: [fab],
	defaultDatatableEmptyLabel: ():{toString():string}=>{
		return i18n.t("common.empty-list");
	}
} as IWinfaktVueComponentsOptions);

Vue.config.productionTip = false;

async function init() {
	await loadLanguageAsync("nl-be");
	(window as any).wfApp = new Vue({
		render: (h) => h(App),
		i18n,
		router,
	}).$mount("#app");
}

init();
